import Assessment from 'containers/Assessment';
import { getStaticPropsWrapper } from 'utils/dataSelectors';
import { PAGES } from 'utils/constants';

export const getStaticProps = getStaticPropsWrapper(PAGES.aiProductAcceleration);

export default Assessment;
